/**
 * Permissions module
 */

import { NgModule } from '@angular/core';
import { PermissionsProviderService } from './permissions-provider.service';
import { PermissionsService } from './permissions.service';
import { IfHasPermissionDirective } from '@components/permissions/directives/if-has-permission.directive';
import { IfHasAnyOfPermissionDirective } from '@components/permissions/directives/if-has-any-of-permission.directive';

@NgModule({
  imports: [],
  providers: [PermissionsService, PermissionsProviderService],
  exports: [IfHasPermissionDirective, IfHasAnyOfPermissionDirective],
  declarations: [IfHasPermissionDirective, IfHasAnyOfPermissionDirective],
})
export class PermissionsModule {}
